import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom"; // Added useNavigate
import Layout from "./components/Layout";
import Home from "./components/Home";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Maintenance from "./components/Maintenance";
import ContactPage from "./components/Contact";
import About from "./components/About";

// ✅ FIX: Updated paths to match your actual file structure (removed .js)
import TermsOfService from "./components/Legal/TermsOfService";
import PrivacyPolicy from "./components/Legal/PrivacyPolicy";

// ✅ Keep these paths if your Login/Reset/Payment files are inside a "Users" folder.
// If you get an error here, change them to "./components/Login", etc.
import LoginPage from "./components/Users/Login";
import ResetPassword from "./components/Users/ResetPassword";
import PaymentSuccess from "./components/Users/PaymentSuccess";

import { ThemeProvider, CssBaseline } from "@mui/material";
import { getTheme } from "./theme";
import { supabase } from "./utils/supabaseClient"; // Import Supabase


function App() {
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";
  // ✅ Restored your Currency and Theme state
  const [userCurrency, setUserCurrency] = useState("USD");
  const [themeMode, setThemeMode] = useState(
    localStorage.getItem("themeMode") || "dark"
  );

  const navigate = useNavigate(); // Hook for auth redirection

  useEffect(() => {
    if (localStorage.getItem("themeMode") === "system") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleSystemThemeChange = (e) => {
        setThemeMode(e.matches ? "dark" : "light");
      };
      mediaQuery.addEventListener("change", handleSystemThemeChange);
      return () =>
        mediaQuery.removeEventListener("change", handleSystemThemeChange);
    }
  }, []);

  return (
    <ThemeProvider theme={getTheme(themeMode)}>
      <CssBaseline />
      {isMaintenanceMode ? (
        <Maintenance />
      ) : (
        <>
          <Routes>
            <Route
              path="/"
              element={
                <Layout
                  setThemeMode={setThemeMode}
                  userCurrency={userCurrency}
                  setUserCurrency={setUserCurrency}
                />
              }
            >
              <Route index element={<Home />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="about" element={<About />} />
              <Route
                path="login"
                element={
                  <LoginPage
                    open={true}
                    onClose={() => window.history.back()} // Go back if they close it
                  />
                }
              />
              <Route path="termsofservice" element={<TermsOfService />} />
              <Route path="privacy" element={<PrivacyPolicy />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="payment-success" element={<PaymentSuccess />} />
            </Route>
          </Routes>
          <SpeedInsights />
          <Analytics />
        </>
      )}
    </ThemeProvider>
  );
}

export default App;
